"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = Modal;
const react_1 = __importStar(require("react"));
const react_aria_1 = require("react-aria");
const clsx_1 = __importDefault(require("clsx"));
__exportStar(require("./ModalTrigger"), exports);
/*
  This has to be a separate element otherwise the focus trap fails. Assuming this is because it needs
  to fit inside the 'Overlay' as a form of context.
*/
function ModalContent({ className, children, ...props }) {
    const ref = (0, react_1.useRef)(null);
    const { dialogProps, titleProps } = (0, react_aria_1.useDialog)(props, ref);
    return (react_1.default.createElement("div", { ...dialogProps, ref: ref, className: (0, clsx_1.default)(`z-50 relative bg-white rounded-lg overflow-hidden outline-0`, className) }, children(titleProps)));
}
function Modal({ isDismissable, state, overlayProps, children, scope, className, ...props }) {
    const ref = (0, react_1.useRef)(null);
    const { modalProps, underlayProps } = (0, react_aria_1.useModalOverlay)({ isDismissable, ...props }, state, ref);
    return (react_1.default.createElement(react_aria_1.Overlay, null,
        react_1.default.createElement("div", { className: scope },
            react_1.default.createElement("div", { ...underlayProps, className: "h-full z-[9998] fixed inset-0 before:z-40 before:fixed before:inset-0 before:bg-black before:bg-opacity-25" },
                react_1.default.createElement("div", { ...modalProps, ref: ref, className: "h-full flex items-center justify-center" },
                    react_1.default.createElement(ModalContent, { ...overlayProps, className: className }, (titleProps) => children(titleProps)))))));
}
